"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApartmentStatuses = void 0;
exports.ApartmentStatuses = {
    created: 'created',
    confirmed: 'confirmed',
    marketing: 'marketing',
    followUp: 'followUp',
    rentContractWanted: 'rentContractWanted',
    rented: 'rented',
    cancelled: 'cancelled'
};
//# sourceMappingURL=apartments.js.map